function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { PureComponent } from "react";
import PictureComponent from "components/core/picture/picture-component";
import TextPartComponent from "/components/core/one-pager/mobile-content/text-part/text-part-component";
import { getAssetPath } from "/services/assets-service";
import { StyledMobileContentComponent } from "./mobile-content-component.scss";
class MobileContentComponent extends PureComponent {
    getTextColor() {
        const { backgroundColor } = this.props.imageWithBackgroundPart;
        return backgroundColor === "transparent" || backgroundColor === "white" ? "black" : "white";
    }
    render() {
        const { textPart, signupForm, collaborationWith, imageWithBackgroundPart, isMobileOnly } = this.props;
        return /*#__PURE__*/ _jsxs(StyledMobileContentComponent, {
            className: "mobile-content-component",
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: "text-part-wrapper",
                    children: /*#__PURE__*/ _jsx(TextPartComponent, _object_spread_props(_object_spread({}, textPart), {
                        signupForm: signupForm,
                        collaborationWith: collaborationWith,
                        customStyle: "mobile-clean-look",
                        color: "black",
                        isMobileCleanLook: true,
                        isMobileOnly: isMobileOnly
                    }))
                }),
                /*#__PURE__*/ _jsx(PictureComponent, {
                    pictureClass: "image-part-wrapper",
                    src: getAssetPath(imageWithBackgroundPart.src),
                    alt: imageWithBackgroundPart.alt
                })
            ]
        });
    }
}
export { MobileContentComponent as default };
MobileContentComponent.defaultProps = {
    collaborationWith: {}
};
